import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Nav from "./nav";
import "../assets/sass/style.scss";

var Header = function Header(_ref) {
  var siteTitle = _ref.siteTitle;
  return React.createElement("header", {
    style: {
      marginBottom: "1.45rem"
    }
  }, React.createElement("div", {
    style: {
      margin: "0 auto",
      maxWidth: 960,
      padding: "1.45rem 1.0875rem"
    }
  }, React.createElement("h1", {
    style: {
      margin: 0
    },
    className: "logo-aranha"
  }, React.createElement(Link, {
    to: "/",
    style: {
      color: "white",
      textDecoration: "none",
      fontSize: 15
    }
  }, siteTitle))), React.createElement("nav", null, React.createElement(Nav, null)));
};

Header.propTypes = {
  siteTitle: PropTypes.string
};
Header.defaultProps = {
  siteTitle: ""
};
export default Header;